module.exports = __webpack_public_path__ + "static/7-service-availability-92a6377e6ebd0215823e54006a6625ac.jpg";